class Page {
  constructor(client) {
    this.client = client
  }

  get(options) {
    return this.client._request({
      method: 'GET',
      path: '/content/api/v2/pages',
      qs: options,
    })
  }
}

module.exports = Page



//////////////////
// WEBPACK FOOTER
// ./~/hubspot/lib/page.js
// module id = fbfX
// module chunks = 1